import React from 'react';
import { ArrowRight } from 'lucide-react';
import { services } from '../../mock';
import { useBooking } from '../../BookingContext';

export default function Services() {
  const { open: onBook } = useBooking();
  return (
    <section id="services" className="py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="zp-section-title">
            Our <span className="zp-gradient-text">Services</span>
          </h2>
          <p className="mt-4 text-slate-600">
            Professional care for your garments. Select a service below to get started and see how we can help you look your best.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map(s => (
            <div
              key={s.key}
              className="group relative rounded-3xl overflow-hidden bg-white shadow-[0_10px_30px_-18px_rgba(20,20,40,0.15)] hover:shadow-[0_24px_50px_-20px_rgba(233,30,128,0.35)] transition-all duration-300 cursor-pointer"
              onClick={onBook}
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={s.image}
                  alt={s.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 rounded-full bg-white/90 text-[#E91E80] text-xs font-semibold">
                    Starts {s.startsAt}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <div className="flex items-center justify-between">
                  <h3 className="text-xl font-bold text-slate-900">{s.title}</h3>
                  <div className="h-9 w-9 grid place-items-center rounded-full bg-pink-50 text-[#E91E80] group-hover:bg-[#E91E80] group-hover:text-white transition-colors">
                    <ArrowRight size={16} />
                  </div>
                </div>
                <p className="mt-2 text-sm text-slate-500">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
